import React, { useState } from "react"
import { createGlobalStyle } from "styled-components"
import tw, { styled } from "twin.macro"
//import breakpoint from 'styled-components-breakpoint'
import { useStaticQuery, graphql, Link } from "gatsby"
//import { Column } from '@ui-kit/helpers'

import Header from "@ui-kit/ecosystems/header"
import Footer from "@ui-kit/ecosystems/footer"

import Main from "../components/display/main"
import Announcements from "../components/announcements"

import Navigation from "@ui-kit/organisms/navigation"
import NavigationMini from "@ui-kit/organisms/navigation/mini"
//import NavigationLarge from '@ui-kit/organisms/navigation/full'
import NavigationTray from "@ui-kit/organisms/navigation/tray"
import Brand from "@ui-kit/atoms/brand"
import AuxiliaryMenu from "@slice/nav/auxiliary"

import Controls from "@slice/controls/controls"
import Tray from "../components/tray"
import Search from "../components/search"

import NotificationProvider from "../context/notification.ctx"
import NovaTheme from "@ui-kit/wrapper"
import PopularLinksMenu from "@slice/nav/popular-links"

import { SkipLink } from "@ui-kit/helpers"

import { MenuRounded, CloseRounded, SearchRounded } from "@mui/icons-material"

const Layout = ({ children, section, tint, ...props }) => {
  const {
    //headerMenu,
    headerMenuResidential,
    headerMenuBusiness,
    //fullMenu,
    //footerMenu,
    fullMenuNew,
    footerMenuResidential,
    footerMenuBusiness,
    auxiliaryMenuResidential,
    auxiliaryMenuBusiness,
    footerMenuLargeBusiness,
    footerMenuLargeResidential,
  } = useStaticQuery(query__layout)

  const [showTray, setShowTray] = useState(false)
  const [showSearchDialog, setShowSearchDialog] = useState(false)
  const [searchIsActive, setSearchIsActive] = useState(false)

  const settings =
    process.env.GATSBY_SITE === "residential"
      ? {
          label: "Residential",
          toggleButtonA: (
            <Link className="is-active" to={"/"}>
              Residential
            </Link>
          ),
          toggleButtonB: (
            <a href="https://business.novaenergy.co.nz">Business</a>
          ),
          headerMenu: headerMenuResidential,
          footerMenu: footerMenuResidential,
          footerMenuLarge: footerMenuLargeResidential,
          footerMenuLargeOpposite: footerMenuLargeBusiness,
          auxiliaryMenu: auxiliaryMenuResidential,
        }
      : {
          label: "Business",
          toggleButtonA: <a href="https://www.novaenergy.co.nz">Residential</a>,
          toggleButtonB: (
            <Link className={"is-active"} to={"/"}>
              Business
            </Link>
          ),
          headerMenu: headerMenuBusiness,
          footerMenu: footerMenuBusiness,
          footerMenuLarge: footerMenuLargeBusiness,
          footerMenuLargeOpposite: footerMenuLargeResidential,
          auxiliaryMenu: auxiliaryMenuBusiness,
        }

  return (
    <NotificationProvider>
      <NovaTheme excludeTypography={true}>
        <Announcements />
        <Style className="layout layout--default" showTray={showTray}>
          <SkipLink href="#main">Skip to main</SkipLink>

          <Header
            data-section={settings.label}
            pre={
              <div className="header__top">
                <SectionToggle className="header__site-toggle">
                  <ul>
                    <li>{settings.toggleButtonA}</li>
                    <li>{settings.toggleButtonB}</li>
                  </ul>
                </SectionToggle>
                {settings.auxiliaryMenu?.tree.length > 0 && (
                  <div className="header__aux-menu">
                    <AuxiliaryMenu tree={settings.auxiliaryMenu.tree} />
                  </div>
                )}
              </div>
            }
          >
            <Brand linkElement={Link} to={"/"} tabIndex={0} />

            <Navigation
              linkElement={Link}
              //items={headerMenu.links}
              tree={settings.headerMenu.tree}
              section={settings.label}
            />

            <Controls className="controls">
              {/*<Link to="/search"><SearchRounded /><span tw="sr-only">Search page</span></Link>*/}
              <button
                aria-label="toggleSearch"
                tw="hidden lg:block"
                type="button"
                onClick={() => setShowSearchDialog(!showSearchDialog)}
              >
                {showSearchDialog ? <CloseRounded /> : <SearchRounded />}
              </button>

              <a
                tw="flex! items-center text-black justify-center lg:hidden! w-8 h-8"
                href="https://novahub.co.nz/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="material-icons material-icons-round text-3xl">
                  person
                </span>
              </a>
              {showTray === false ? (
                <button
                  tw="lg:hidden"
                  aria-label="toggleSearch"
                  type="button"
                  onClick={() => setShowTray(!showTray)}
                >
                  <SearchRounded />
                </button>
              ) : null}
              <button
                aria-label="toggleMenu"
                tw="portrait:lg:block lg:hidden"
                type="button"
                onClick={() => setShowTray(!showTray)}
              >
                {showTray === true ? <CloseRounded /> : <MenuRounded />}
              </button>

              {showSearchDialog && (
                <SearchDialogStyle>
                  <Search />
                  <ol tw="list-none w-full flex mt-3 mx-0 mb-0 gap-2 text-sm items-center">
                    <li tw="text-xs font-medium text-gray-400 tracking-wide uppercase">
                      Popular searches
                    </li>
                    {[
                      {
                        title: "Emergencies",
                        url: "/help-advice/emergencies-outages",
                      },
                      {
                        title: "Medically Dependent",
                        url: "/help-advice/medical-dependant",
                      },
                      {
                        title: "Broadband & Phone",
                        url: "/help-advice/broadband",
                      },
                      {
                        title: "Meters",
                        url: "/help-advice/meters",
                      },
                      {
                        title: "Service fees",
                        url: "/help-advice/billing-payments/novas-fees/",
                      },
                      {
                        title: "Billing & payments",
                        url: "/help-advice/billing",
                      },
                    ].map((tag) => (
                      <li key={tag.url}>
                        <Link to={tag.url}>{tag.title}</Link>
                      </li>
                    ))}
                  </ol>
                </SearchDialogStyle>
              )}
            </Controls>
          </Header>
            <Main id="main" tint={tint}>
              {children}
            </Main>
          <Footer
            prefooter={
              <PopularLinksMenu
                tree={settings.footerMenuLarge.tree}
                otherSite={settings.footerMenuLargeOpposite.tree}
                otherSitePrefix={process.env.GATSBY_SITE === 'residential' ? 'business' : 'www'}
                className={""}
              />
            }
          >
            <div className="copyright prose">
              <p>&copy; {new Date().getFullYear()} - Nova Energy </p>
            </div>

            <NavigationMini
              linkElement={Link}
              tree={settings.footerMenu.tree}
              remove={`/${process.env.GATSBY_SITE}`}
            />

            <ExtraLogos className="extra-logos">
              <a
                href="https://www.powerswitch.org.nz/"
                rel="nofollow noopener noreferrer"
              >
                <img
                  src="/powerswitch.svg"
                  alt="Powerswitch by Consumer"
                  height={22}
                  width={121}
                />
                <small>Powerswitch is an energy comparison website</small>
              </a>
              <a
                href="https://www.utilitiesdisputes.co.nz/"
                target="_blank"
                rel="nofollow noopener noreferrer"
              >
                <img
                  src="/utilitiesdisputes.svg"
                  alt="Utilities Disputes"
                  height={31}
                  width={96}
                />
                <small>
                  Utility Disputes provides independent
                  <br />
                  help with unresolved energy complaints
                </small>
              </a>
              <a
                href="https://www.tdr.org.nz/"
                target="_blank"
                rel="nofollow noopener noreferrer"
              >
                <img
                  src="/tdr.svg"
                  alt="Telecommunications Dispute Resolution"
                  height={31}
                  width={170}
                />
                <small>Telecommunications Dispute Resolution</small>
              </a>
            </ExtraLogos>

            <Brand linkElement={Link} to={"/"} />
          </Footer>

          <Tray className="tray" tabIndex={showTray === true ? "1" : "-1"}>
            <Search
              prefocus={showTray}
              callback={(searchActive) => setSearchIsActive(searchActive)}
            />
            {searchIsActive === false && (
              <NavigationTray
                linkElement={Link}
                tree={settings.headerMenu.tree}
                aux={settings.auxiliaryMenu.tree}
                remove={`/${process.env.GATSBY_SITE}`}
              />
            )}
          </Tray>
          {showTray === true && <LockBody />}
        </Style>
      </NovaTheme>
    </NotificationProvider>
  )
}

export default Layout

const LockBody = createGlobalStyle`
    html, body {
        overflow: hidden;
        position: fixed;

    }
`

const Style = styled.div`
  grid-template-areas:
    "customer-type tray"
    "header tray"
    "main tray"
    "footer tray";

  --header-height: 102px;

  @media (min-width: 768px) {
    --header-height: 125px;
  }

  ${tw`
        grid
        min-h-screen
        motion-safe:transition-transform
        xl:transform-none
        gridTemplateRows[minmax(auto, min-content) minmax(var(--header-height), min-content) 1fr auto]
        gridTemplateColumns[100vw 85vw]
        lg:gridTemplateColumns[100vw 75vw]
        xl:gridTemplateColumns[100vw 0]
    `}

  ${({ showTray }) =>
    showTray === true
      ? tw`transform[translateX(-85vw)] lg:transform[translateX(-75vw)] max-h-screen`
      : ""}


    > .customer-type {
    grid-area: customer-type;
  }

  > header {
    grid-area: header;

    ${tw`fixed top-0 w-full height[var(--header-height)] bg-white z-30`}

    .site__column {
      ${tw`relative`}
    }
  }
  > .main {
    grid-area: main;
  }
  > footer {
    grid-area: footer;
  }

  .tray {
    grid-area: tray;
    grid-row: 1 / footer-end;
  }
`

const ExtraLogos = styled.div`
  ${tw`flex items-center justify-center gap-8`}

  a {
    ${tw`flex flex-col justify-center items-start w-1/2 lg:w-auto outline-none focus-visible:outline[2px solid var(--nova-orange)]`}
    color: var(--nova-default);
    line-height: 1.25;
    width: 50%;

    small {
      display: block;
      display: none;
      margin-top: 0.5em;
      text-align: center;
    }
  }

  img {
    margin-bottom: 0;
  }
`

const SectionToggle = styled.div`
  ${tw`flex text-base items-center gap-4 md:text-base xl:fontSize[calc(.75em + .5vmax)] mg:fontSize[calc(.75em + .5vmax)] antialiased bg-white height[40px]`}

  > ul {
    ${tw`container mx-auto w-full px-4 my-0 flex items-center justify-end lg:justify-start lg:pl-64 list-none gap-x-2 md:gap-x-5 font-semibold`}

    > li {
      ${tw`mb-0`}
    }

    a {
      ${tw`outline-none text-default`}
      &.is-active {
        ${tw`text-primary underline textUnderlineOffset[.15em]`}
      }
    }
  }
`

const SearchDialogStyle = styled.div`
  ${tw`absolute hidden lg:block bg-white p-5 rounded-lg top-16 shadow-xl width[80vw] max-w-5xl right-0`}

  ol a {
    ${tw`text-gray-900 underline hover:text-primaryDark antialiased`}
  }

  ul.search__results {
    ${tw`maxHeight[calc(64px * 6)] overflow-y-scroll`}
  }
`

const query__layout = graphql`
  query {
    headerMenuResidential: menu(name: { eq: "residential" }) {
      tree {
        link {
          title
          url
        }
        subtree {
          link {
            url
            title
          }
        }
      }
    }
    headerMenuBusiness: menu(name: { eq: "business" }) {
      tree {
        link {
          title
          url
        }
        subtree {
          link {
            url
            title
          }
        }
      }
    }

    auxiliaryMenuResidential: menu(name: { eq: "auxiliary" }) {
      tree {
        link {
          title
          url
          options {
            attributes {
              className: class
              rel
              target
            }
          }
        }
      }
    }
    auxiliaryMenuBusiness: menu(name: { eq: "auxiliary-business" }) {
      tree {
        link {
          title
          url
          options {
            attributes {
              className: class
              rel
              target
            }
          }
        }
      }
    }

    footerMenuLargeBusiness: menu(name: { eq: "business-footer-lg" }) {
      tree {
        link {
          title
          url
        }
        subtree {
          link {
            url
            title
          }
        }
      }
    }

    footerMenuLargeResidential: menu(name: { eq: "residential-footer-lg" }) {
      tree {
        link {
          title
          url
        }
        subtree {
          link {
            url
            title
          }
        }
      }
    }

    footerMenuResidential: menu(name: { eq: "residential-footer" }) {
      tree {
        link {
          title
          url
        }
      }
    }
    footerMenuBusiness: menu(name: { eq: "business-footer" }) {
      tree {
        link {
          title
          url
        }
      }
    }
  }
`
